import React from 'react';
import { AppContext, LagoonContext } from '@src/AppContext';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';

const Wrapper = styled('div', {
  padding: '16px 16px 16px 80px',
  '@screen >= $xs': {
    paddingLeft: '16px',
  },
  '@screen >= $xl': {
    paddingLeft: '80px',
  },
});

const Title = styled('h4', {
  minHeight: '20px !important',
  color: 'rgb(0, 38, 119) !important',
  fontSize: '16px !important',
  fontWeight: 'bold !important',
  lineHeight: '20px !important',
  margin: '20px 0 !important',
});

const SubTitle = styled('h5', {
  minHeight: '18px !important',
  color: 'rgb(51, 51, 51) !important',
  fontSize: '16px !important',
  fontWeight: 'bold !important',
  letterSpacing: '0px !important',
  lineHeight: '18px !important',
  margin: '10px 0 !important',
});

const StyledHr = styled('hr', {
  margin: '15px 0',
});

export function Filters() {
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext?.getTable('feature-toggles');
  const providerAccessToggle = featureToggles?.getRow(
    'PROVIDER_ACCESS_TOGGLE'
  )?.enabled;
  const appointmentToggle =
    featureToggles?.getRow('APPOINTMENT_TOGGLE')?.enabled;
  const { filters = [], updateFilters } = React.useContext(AppContext);

  const excludedFilters = [];
  if (!providerAccessToggle) excludedFilters.push('Provider Access');
  if (!appointmentToggle) excludedFilters.push('Appointment');

  const filtersData = filters.filter((item) => {
    return !excludedFilters.includes(item.title);
  });

  const filtersInteractionEvent = (idx) => {
    const interactionName = filtersData?.[idx].checked
      ? 'category select'
      : 'category deselect';
    const interactionValue = `Category: ${filtersData?.[idx]?.title}`;
    const interactionContext = 'filter clicks';
    event('INTERACTION_EVENT', {
      interactionName,
      interactionValue,
      interactionContext,
    });
  };

  const onChange = (e, idx) => {
    filtersData[idx].checked = !filtersData[idx].checked;
    updateFilters([...filtersData]);
    filtersInteractionEvent(idx);
  };

  return (
    <Wrapper>
      <SubTitle>Filters</SubTitle>
      <hr />
      <Title>Category</Title>
      {filtersData.map((filter, idx) => {
        return (
          <Checkbox
            label={filter.title}
            isChecked={filter.checked}
            onChange={(e) => {
              return onChange(e, idx);
            }}
          />
        );
      })}
      <StyledHr />
    </Wrapper>
  );
}
